import { theme } from '@ketch-com/deck'
import { Box, CircularProgress } from '@mui/material'

export type SemiCircleProps = {
  containerWidth: number
  containerHeight: number
  size: number
  value: number
  thickness: number
  top: number
  left: number
  color?: string
}

export function SemiCircle({
  containerWidth,
  containerHeight,
  size,
  value,
  thickness,
  top,
  left,
  color,
}: SemiCircleProps) {
  const defaultColor = theme.palette.primary.main
  let progressBarColor = color || defaultColor
  let progressLineColor = theme.palette.Black.o16

  if (value >= 50) {
    progressBarColor = theme.palette.Success.PrimaryLight
    progressLineColor = theme.palette.Success.PrimaryDark
  }

  return (
    <Box height={containerHeight} width={containerWidth} overflow="hidden" position="relative">
      <Box sx={{ transform: 'rotate(-90deg)' }} position="absolute" top={top} left={left}>
        <CircularProgress
          variant="determinate"
          value={value}
          size={size}
          thickness={thickness}
          sx={{ color: progressBarColor }}
        />
      </Box>
      <Box sx={{ transform: 'rotate(-90deg)' }} position="absolute" top={top} left={left}>
        <CircularProgress
          variant="determinate"
          value={50}
          size={size}
          thickness={0.25}
          sx={{ color: progressLineColor }}
        />
      </Box>
    </Box>
  )
}
